/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthStrictHttpResponse } from '../../auth-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UserGetUserOrganizationsGet$Params {
  id?: string;
}

export function userGetUserOrganizationsGet(http: HttpClient, rootUrl: string, params?: UserGetUserOrganizationsGet$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<Array<string>>> {
  const rb = new RequestBuilder(rootUrl, userGetUserOrganizationsGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AuthStrictHttpResponse<Array<string>>;
    })
  );
}

userGetUserOrganizationsGet.PATH = '/User/GetUserOrganizations';
